module.exports = __webpack_public_path__ + "img/pin-3000.1595ca54.png";